// extracted by mini-css-extract-plugin
export default {"container":"qp-z","brandName":"rp-z","productName":"sp-z","productNamePdpEnhancements":"tp-z","breakLongProductName":"up-z"};